const servicePriorities = {
  NOT_PRIORITARY: { value: 0, label: 'notPrioritary' },
  LOW_PRIORITY: { value: 1, label: 'lowPriority' },
  MEDIUM_PRIORITY: { value: 2, label: 'mediumPriority' },
  HIGH_PRIORITY: { value: 3, label: 'highPriority' },
};

export { servicePriorities };
